import React from 'react';
import {Links, Meta, Scripts} from 'react-router';

import {getAssetUrl} from 'coreUtils/adapters/sdk';

import {SSR_STYLE_ELEMENT_ID} from 'brandConstants';

/** `<script type="application/json">` with the server globals, written by `entry.server` at the end of the document. */
export const MOBIFY_DATA_ELEMENT_ID = 'mobify-data';
export const BUNDLE_SCRIPT_ELEMENT_ID = 'thp-bundle-config';

/**
 * Sets `window._BUNDLE_PATH` before any module script runs, so that Vite asset URLs
 * (see `renderBuiltUrl` in `packages/vite`) resolve to `/mobify/bundle/<BUNDLE_ID>/client/`.
 */
const BundleScript = () => {
	const bundlePath = typeof window === 'undefined' ? `${getAssetUrl()}client/` : window._BUNDLE_PATH;

	return (
		<script
			id={BUNDLE_SCRIPT_ELEMENT_ID}
			suppressHydrationWarning
			dangerouslySetInnerHTML={{__html: `window._BUNDLE_PATH=${JSON.stringify(bundlePath)};`}}
		/>
	);
};

/**
 * Root `Layout` of brands on React Router 7: the HTML shell that the PWA Kit renderer used to
 * build by string concatenation. Elements whose content is only known once rendering is done
 * (SSR global styles, `<html>` attributes) are rendered empty here and filled in by `entry.server`;
 * `suppressHydrationWarning` keeps the server content on hydration. The `mobify-data` globals are
 * not part of the React tree: `entry.server` writes them before `</body>` at the end of the stream
 * (React 19 skips unexpected tags at the end of `<body>` when hydrating).
 */
const Document = ({children}: {children: React.ReactNode}) => (
	<html suppressHydrationWarning>
		<head>
			<meta charSet="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0" />
			<meta name="format-detection" content="telephone=no" />
			<meta name="theme-color" content="#fffffe" />
			<link rel="manifest" href={getAssetUrl('static/manifest.json')} />
			<BundleScript />
			<Meta />
			<Links />
			<style id={SSR_STYLE_ELEMENT_ID} suppressHydrationWarning dangerouslySetInnerHTML={{__html: ''}} />
		</head>
		<body suppressHydrationWarning>
			<div className="react-target" id="react-target">
				{children}
			</div>
			<Scripts />
		</body>
	</html>
);

export default Document;
